import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, MasterPages, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { Header } from "../../../Components/Header/Header";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { HeaderList } from "../../../Components/Header/HeaderList";
import WSMobViewDataGrid, { IMobColumns } from "../../../Components/DataGrid/WSMobViewDataGrid";
import WSNotificationFramework from "../../../Components/Notifications/Firbase/WSNotificationFramework";
import { AllPermissions, getPermissions } from "../../../commonFunctions/PermissionManger";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";


export const DealList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add,edit,remove, view} =AllPermissions.getDealPermission;
    const navigate = useNavigate();
    const [dealListData, setDeallistData] = useState<any>([])
    const isMobile = IsSmallScreen();

    const [totalCount, setTotalCount] = useState<any>(0);
 
    const source = {
        url: "leads/search",
        page: 1,
        pageSize: 10,
        filter: [
            {
                "field": "leadType",
                "operator": "eq",
                "value": "0"
            }
        ],
        sort: [],
    };


    useEffect(() => {

        const getDeals = async () => {
            try {

                const response: any = await callAPI('deals', Method.GET, null, null);
                setTotalCount(response?.length || 0)
                setDeallistData(response || []);
            }
            catch (e) {

            }
        }
        getDeals();
    }, [])
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/deal/edit/${row?.id}`)
        }

    };
    const columns: IColumns[] = [
        {
            header: "Deal Name",
            fieldName: "dealName",
            tooltip: true,
            type: 'default',
            
        },
        {
            header: "stage",
            fieldName: "stage",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "amount",
            tooltip: true,
            type: 'default'
        },
        {
            header: "status",
            fieldName: "status",
            tooltip: true,
            type: 'status'
        },

        {
            header: "closeDate",
            fieldName: "closeDate",
            tooltip: true,
            type: 'date'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit",],
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Deal Name",
            fieldName: "dealName",
            tooltip: true,
            type: 'default',
            labelSx:{fontWeight:'bold'}
        },
        {
            header: "stage",
            fieldName: "stage",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "amount",
            tooltip: true,
            type: 'default'
        },

        {
            header: "closeDate",
            fieldName: "closeDate",
            tooltip: true,
            type: 'date'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const handleClick = () => {
        navigate('/deal/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="dealMainListGrid"
                        title="Deals"
                        columns={columns}
                        data={dealListData}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Deals'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="dealMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />}
            </Grid>
        </>
    )
})